import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, EMPTY, map, Observable, throwError } from 'rxjs';
import { environment } from '@environments/environment';
import { CommonService } from '@services/common.service';
import { ToastrService } from 'ngx-toastr';
import { Obj } from '@popperjs/core';

@Injectable()
export class httpInterceptor implements HttpInterceptor {

  private commonService = inject(CommonService);
  private toastr = inject(ToastrService);

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      map((res: Obj[string]) => {
        if (res.body) {
          if (res.body._status_code == 401) {
            if (environment.production) {
              let url = '';
              if (environment.mode == 'Prod') {
                url = environment.errorHandling.error_code_401.Prod_url; // prod
              } else {
                url = environment.errorHandling.error_code_401.dev_url; // Dev
              }
              this.commonService.clearSession();
              window.location.href = environment.authLoginUrl + url;
            }
            return EMPTY;
          }
        }
        return res;
      }),
      catchError((err: Obj[string]) => {
        if (err.status === 504) {
          this.commonService.setShowLoader(false);
          this.toastr.error(
            environment.errorHandling.error_code_504.message
          );
        }

        if (err.status === 500) {
          this.commonService.setShowLoader(false);
          this.toastr.error(
            environment.errorHandling.error_code_500.message
          );
        }


        if (err.status === 401) {
          if (environment.production) {
            let url = '';
            if (environment.mode == 'Prod') {
              url = environment.errorHandling.error_code_504.Prod_url; // prod
            } else {
              url = environment.errorHandling.error_code_504.dev_url; // Dev
            }
            this.commonService.clearSession();
            window.location.href = environment.authLoginUrl + url;
          }
          return EMPTY;
        } else {
          return throwError(() => new Error(err));
        }
      })
    );
  }
}
